import React from "react";

const MallabhumPrayas = (props) => {
  const getWidth = () => window.innerWidth;
  const getFontSize = () => {
    const width = getWidth();
    return props?.small ? "8px" : width < 600 ? "15px" : "30px"; // Adjust font size based on screen width
  };

  return (
    <div
      style={{
        padding: "1px",
        textAlign: "center",
        fontFamily: "Arial, sans-serif",
        display: "flex", // Use flexbox for alignment
        alignItems: "center", // Center items vertically
        justifyContent: "center", // Center items horizontally
        flexDirection: "column", // Stack items vertically
      }}
    >
      <div style={{ display: "flex", alignItems: "center" }}>
        <div
          style={{
            display: "inline",
            backgroundColor: "#CADB2A",
            color: "black",
            padding: "5px 10px",
            fontSize: getFontSize(), // Use dynamic font size
            fontWeight: "bold",
          }}
        >
          Mallabhum
        </div>
        <div
          style={{
            display: "inline",
            backgroundColor: "#008041",
            color: "#FFFFFF",
            padding: "5px 10px",
            fontSize: getFontSize(), // Use dynamic font size
            fontWeight: "bold",
          }}
        >
          Prayas
        </div>
      </div>
      {props.isDialogueRequired && (
        <div
          style={{
            marginTop: "10px", // Space between the main text and tagline
            fontSize: getWidth() < 600 ? "10px" : "20px", // Slightly smaller font size for the tagline
            color: "#f9f9f9", // Dark gray color for the tagline
            fontStyle: "italic", // Italic style for the tagline
          }}
        >
          মানুষের সাথে মানুষের পাশে
        </div>
      )}
    </div>
  );
};

export default MallabhumPrayas;
